import {
  WidgetDirectivesRepository,
  WidgetRepository,
} from '@framework/engine';
import { initThemeWidgetRepository } from '#theme';
import { ApplicantDataDirectiveType } from './directives/applicant-data/ApplicantDataDirective.type';
import { IntegrableDirectiveType } from './directives/integrable/IntegrableDirective.type';
import { MetadataDirectiveType } from './directives/metadata/MetadataDirective.type';
import { OmissisDirectiveType } from './directives/omissis/OmissisDirective.type';
import { OutcomeActionDirectiveType } from './directives/outcome-action/OutcomeActionDirective.type';
import { TableSaveDirectiveType } from './directives/table-save/TableSaveDirective.type';
import { BurdenWidgetType } from './widgets/burden/BurdenWidget.type';
import { CompetenceWidgetType } from './widgets/competence/CompetenceWidget.type';
import { DownloadWidgetType } from './widgets/download/DownloadWidget.type';
import { EmailVerificationWidgetType } from './widgets/email-verification/EmailVerificationWidget.type';
import { MapWidgetType } from './widgets/map/MapWidget.type';
import { ModuleTriggerWidgetType } from './widgets/module-trigger/ModuleTriggerWidget.type';
import { ProvinceWidgetType } from './widgets/province/ProvinceWidget.type';
import { UploadWidgetType } from './widgets/upload/UploadWidget.type';

export const initCommonWebWidgetRepository = () => {
  console.log('@framework/common-web: initCommonWebWidgetRepository');
  /**
   * Widget per selezionare la Competenza
   */
  WidgetRepository.register(CompetenceWidgetType);
  /**
   * Oneri
   */
  WidgetRepository.register(BurdenWidgetType);
  /**
   * Upload
   */
  WidgetRepository.register(UploadWidgetType);
  /**
   * Email Verification
   */
  WidgetRepository.register(EmailVerificationWidgetType);
  /**
   * Download File
   */
  WidgetRepository.register(DownloadWidgetType);
  /**
   * Mappe
   */
  WidgetRepository.register(MapWidgetType);
  /**
   * Attivazione moduli
   */
  WidgetRepository.register(ModuleTriggerWidgetType);
  /**
   * Città e Provincia
   */
  WidgetRepository.register(ProvinceWidgetType);
  // Direttive
  /**
   * Funzionalità del "salva in tabella"
   */
  WidgetDirectivesRepository.register(TableSaveDirectiveType);
  /**
   * Dati del titolare della richiesta
   */
  WidgetDirectivesRepository.register(ApplicantDataDirectiveType);
  /**
   * Gestione dell'opzionalità delle sezioni in bse all'esito selezionato
   */
  WidgetDirectivesRepository.register(OutcomeActionDirectiveType);
  /**
   * Esportazione dei metadati
   */
  WidgetDirectivesRepository.register(MetadataDirectiveType);
  /**
   * Omissis
   */
  WidgetDirectivesRepository.register(OmissisDirectiveType);
  /**
   * Modifica del campo in fase di integrazione
   */
  WidgetDirectivesRepository.register(IntegrableDirectiveType);

  initThemeWidgetRepository();
};
